import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Tag } from '../../interfaces/Tag/Tag';
import { getTags } from '../../api/Tag';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { TagsTable } from './TagsTable';

export const TagsPage = () => {
  const navigate = useNavigate();

  const [tags, setTags] = useState<Tag[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshTags = () => {
    setLoading(true);
    getTags()
      .then((t) => setTags(t))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshTags();
  }, []);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Etiketler
      </Typography>
      <Waiting open={loading} />
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        onClick={() => navigate('/products/tags/new')}
        sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
      >
        Yeni Etiket
      </Button>
      <TagsTable tags={tags} />
    </Box>
  );
};
